import axiosInstance from "../axiosInstance";
import API_ROUTES from "../apiRoutes";

export const GoldAPI = {
  getGoldRates: () => axiosInstance.get(API_ROUTES.GOLD.GET_GOLD_RATES),
  getGoldRatesWithApi: () =>
    axiosInstance.post(API_ROUTES.GOLD.GET_GOLD_RATES_WITH_API),
  addGoldRate: (data) =>
    axiosInstance.post(API_ROUTES.GOLD.ADD_GOLD_RATE, data),
  updateGoldRate: (id, data) =>
    axiosInstance.put(`${API_ROUTES.GOLD.UPDATE_GOLD_RATE}/${id}`, data),
  deleteGoldRate: (id) =>
    axiosInstance.delete(`${API_ROUTES.GOLD.DELETE_GOLD_RATE}/${id}`),
};
